import CheckmateApiClient from '../../../../services/apiClient';
import { HttpResponseError } from '../../../../interfaces/IHttpResponseError';
import { ISameCaseMatchedCasesSearchModel } from '../../../../pages/quad/same-cases-admin/manage/useGetSameCasesQuery';
import { useQuery } from 'react-query';

const _apiClient = new CheckmateApiClient();

export interface ISameCaseMatchCaseResponseModel {
    caseGuid: string;
    organizationGuid: string;
    organizationName: string;
    caseNumber: string;
    caseName: string;
    jurisdiction: string;
    caseGroupGuid?: string | null;
}

export const useGetSearchSameCasesAdmin = (searchModel: ISameCaseMatchedCasesSearchModel) => {
    return useQuery({
        queryKey: ['get-search-case-groups-admin-query', { searchModel }],
        queryFn: async () => {
            const response = await _apiClient.searchSameCasesAdmin(searchModel);

            if (response?.httpResponse.status === 401) {
                window.location.reload();
            }

            if (!response?.httpResponse.ok) {
                const error: HttpResponseError = new Error('Failed to search same cases');
                error.status = response.httpResponse.status;
                throw error;
            }

            return response.payload;
        },
        cacheTime: 0,
        staleTime: 0,
    });
};
